export default __webpack_public_path__ + "static/highlight-pattern2-6778979646fa496ace6a2151bc141fef.svg";